export const supportPages = {
  root: '/support',
  invoiceQuotationMissing: {
    name: '/support/invoiceQuotationMissing',
    navigate: () => `/support/invoiceQuotationMissing`,
  },
  companyLastDocs: {
    name: '/support/companyLastDocs',
    navigate: () => `/support/companyLastDocs`,
  },
  imageResizer: {
    name: '/support/imageResizer',
    navigate: () => `/support/imageResizer`,
  },
  accountSubcriptionDateMissing: {
    name: '/support/accountSubcriptionDateMissing',
    navigate: () => `/support/accountSubcriptionDateMissing`,
  },
  accountResiliationDateMissing: {
    name: '/support/accountResiliationDateMissing',
    navigate: () => `/support/accountResiliationDateMissing`,
  },
  subAccountNotSyncWithBossAccount:{
    name: '/support/subAccountNotSyncWithBossAccount',
    navigate: () => `/support/subAccountNotSyncWithBossAccount`,
  },
  subAccountNotSyncWithBossAccountDemo :{
    name: '/support/subAccountNotSyncWithBossAccountDemo',
    navigate: () => `/support/subAccountNotSyncWithBossAccountDemo`,
  },
}
